import { ApiKy } from './index'
import { EventCount, EventSingle, EventsResponse } from '~/types/event'

export default class Api extends ApiKy {
  async getAll(params?: {
    page?: number
    pageSize?: number
    name?: string
    customerName?: string
    subscriptionName?: string
    orderBy?: string
    asc?: boolean
  }): Promise<EventsResponse> {
    return this.ky
      .get('sync-tasks/subscriptions', {
        searchParams: params as Record<string, string | number>,
      })
      ?.json<EventsResponse>()
  }

  async getSingle(eventId: string): Promise<EventSingle> {
    return this.ky
      .get(`sync-tasks/subscriptions/${eventId}`)
      ?.json<EventSingle>()
  }

  async retryTask(taskId: string): Promise<unknown> {
    return this.ky.post(`sync-tasks/${taskId}/process`).json()
  }
  async getEventsCount(): Promise<EventCount> {
    return this.ky.get('sync-tasks/count').json()
  }
  async deleteTask(taskId: string): Promise<Response> {
    return this.ky.delete(`sync-tasks/${taskId}`)
  }
}
